import { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  getDefaultEducationPeriod,
  setDefaultEducationPeriodCode,
} from 'legacy-src/actions/educationPeriod';
import useFetchStudent from './useFetchStudent';
import useFetchTeacher from './useFetchTeacher';
import useFetchAdminCoord from './useFetchAdminCoord';

const useFetchUserInfo = (props) => {
  const { client, userData, subject, dispatch, router, params } = props;
  const { isStudent, isTeacher, isAdmin, isCoordinator } = userData;
  const isAdminCoordinator = isAdmin || isCoordinator;
  const [studentResponse, getStudentInfo] = useFetchStudent({
    client,
    subject,
    dispatch,
  });
  const [teacherResponse, getTeacherInfo, isLoadingTeacherInfo] =
    useFetchTeacher({
      client,
      subject,
      dispatch,
    });
  const [adminCoordResponse, getAdminCoordInfo] = useFetchAdminCoord({
    client,
    subject,
    dispatch,
  });

  useEffect(() => {
    if (subject) {
      const { educationPeriodCode: { id: educationPeriodCode } = {} } =
        getDefaultEducationPeriod({
          subject,
          userData,
        }) || {};

      dispatch(
        setDefaultEducationPeriodCode({ educationPeriodCode, userData }),
      );

      if (isStudent) {
        getStudentInfo({
          educationPeriodCode,
          userData,
          router,
          params,
        });
      } else if (isTeacher) {
        getTeacherInfo({
          educationPeriodCode,
          userData,
          router,
          params,
        });
      } else if (isAdminCoordinator) {
        getAdminCoordInfo({
          userData,
          router,
          params,
        });
      }
    }
  }, [subject, isStudent, isTeacher, isAdminCoordinator]);

  return [
    studentResponse || teacherResponse || adminCoordResponse,
    isLoadingTeacherInfo,
  ];
};

useFetchUserInfo.propTypes = {
  client: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  subject: PropTypes.string.isRequired,
};

export default useFetchUserInfo;
